<template>
    <div>
        <div class="like_share_wrap b-0">
            <ul class="like_share_list">
                <li>
                <router-link to="" class="btn btn-likes">
                    <i class="fas fa-share px-2"></i>{{ t('Share') }}
                </router-link>
                </li>
                <li>
                <router-link to="" class="btn btn-likes">
                    <i class="fas fa-heart px-2"></i>{{ t('Save') }}
                </router-link>
                </li>
            </ul>
            <ul class="full-width-row">
                <li>
                <a
                    :href="'https://wa.me/' + props.item?.whatsapp"
                    class="btn btn-likes"
                    target="_blank"
                >
                    <i class="fab fa-whatsapp px-2"></i>{{ $t('whatsapp') }}
                </a>
                </li>
            </ul>
        </div>

        <div class="details-sidebar">
            <div class="sidebar-widgets">                
                <h4>{{$t('Featured service providers')}}</h4>                
                <div class="sidebar_featured_property">
                    <div class="vertical-marquee-container">
                        <div class="vertical-marquee-content" :style="{ animationDuration: marqueeDuration }">
                            <div
                            v-for="(provider, index) in featuredProviders"
                            :key="index"
                            class="vertical-marquee-item flex items-center gap-2"
                            >
                                <UserIcon class="w-5 h-5 text-primary" />
                                <router-link
                                    :to="`/service-provider/show-details/${provider.id}`"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                >
                                    {{ provider.name }}&nbsp; {{ provider.category.name }}
                                </router-link>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <br>
            <div class="sides-widget">
                <!-- <div class="slider" :style="{ transform: `translateX(-${currentIndex * 100}%)` }">
                <div
                    v-for="(ad, index) in filteredAds"
                    :key="index"
                    class="slide"
                    @click="openAd(ad.link)"
                >
                    <img :src="ad.image" :alt="'Ad ' + index" />
                </div>
                </div> -->
                <div
                    v-for="(ad, index) in filteredAds"
                    :key="index"
                    @click="openAd(ad.link)"
                    class="ad-item"
                >
                    <img :src="ad.image" :alt="'Ad ' + index" />
                </div>
            </div>
        </div>
    </div>
</template>

<script setup>
    import { useI18n } from 'vue-i18n';
    import { defineProps } from "vue";
    import { ref, onMounted, onUnmounted, watch, computed } from 'vue';
    import axios from 'axios';
    import { useRoute } from 'vue-router';
    import { UserIcon } from '@heroicons/vue/24/outline'
    const { t } = useI18n();
    const props = defineProps({
    item: {
        type: Object,
        required: true,
    }
    });
    const route = useRoute();
    const ads = ref([]);
    const loading = ref(false);
    const observer = ref(null);
    const { locale } = useI18n();
    const fetchAds = async () => {
        loading.value = true;
        try {
            const { data } = await axios.get('/get-ads', {
                params: {
                        category_id: props.item?.category?.id || null,
                        state_id: props.item?.state?.id || null,
                        type: "web"
                }
            });

            ads.value = data.ads || [];

        } catch (error) {
            console.error("Error fetching ads:", error);
        } finally {
            loading.value = false;
        }
    };

    watch(() => route.query, fetchAds, { deep: true });
    const currentIndex = ref(0);
    const interval = ref(null);

    const filteredAds = computed(() => ads.value.filter(ad => ad.place === 'sidebar_ad'));

    const startSlider = () => {
    interval.value = setInterval(() => {
        if (filteredAds.value.length > 0) {
        currentIndex.value = (currentIndex.value + 1) % filteredAds.value.length;
        }
    }, 3000);
    };

    const stopSlider = () => {
    clearInterval(interval.value);
    };

    const openAd = (url) => {
    window.open(url, '_blank');
    };

    const featuredProviders = ref([])
    const fetchFeaturedProviders = async () => {
    try {
        const res = await axios.get("/users/list-service-provider-without-paginate?featured=featured",{
            headers: {
                'locale': locale.value
            }
        });

         featuredProviders.value = res.data.service_providers;

    } catch (error) {
        console.error('Error fetching featured providers:', error);
    }
    };
    const marqueeDuration = computed(() => {
      const count = featuredProviders.value.length;
      if (count === 0) return "30s"; // default if no data
      return `${count * 5}s`; // 5s per item — adjust multiplier if needed
    });
    const setupObserver = () => {
        observer.value = new IntersectionObserver((entries) => {
            if (entries[0].isIntersecting && !loading.value) {
                fetchAds();
            }
        });

        const sentinel = document.getElementById('scroll-sentinel');
        if (sentinel) observer.value.observe(sentinel);
    };

    onMounted(() => {
        fetchAds();
        setupObserver();
        startSlider();
        fetchFeaturedProviders();
    });

    onUnmounted(() => {
        stopSlider();
        if (observer.value) observer.value.disconnect();
    });
</script>
<style scoped>
.ad-item {
  margin-bottom: 16px;
}
.sides-widget {
  width: 100%;
  overflow: hidden;
  position: relative;
}

.slider {
  display: flex;
  transition: transform 0.5s ease-in-out;
}

.slide {
  min-width: 100%;
  cursor: pointer;
}

.slide img {
  width: 100%;
  height: auto;
  display: block;
}
.vertical-marquee-container {
  height: 150px;
  overflow: hidden;
  background: #fff;
  border-radius: 8px;
  position: relative;
}

.vertical-marquee-content {
  display: flex;
  flex-direction: column;
  animation: scroll-up linear infinite;
}

.vertical-marquee-item {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 10px;
  font-weight: bold;
  font-size: 1em;
  color: #333;
}
/* Animation */
@keyframes scroll-up {
  0% {
    transform: translateY(0%);
  }
  100% {
    transform: translateY(-50%);
  }
}
</style>